import { createRouter, createWebHashHistory } from 'vue-router'

const requireAuth = (to, from, next) => {
  const token = localStorage.getItem('jwt');
  const expiration = new Date(localStorage.getItem('tokenExpiration')).getTime(); // <- konwersja
  const isLoggedIn = token && expiration && Date.now() < expiration;
  
  if (!isLoggedIn) {
    return next({ path: '/' });
  }

  next();
};

const requireAdmin = (to, from, next) => requireAuth(to, from, destination => {
  if (destination) return next(destination);
  if (localStorage.getItem('userType') !== 'ADMIN') return next({ name: 'Sale' });
  next();
});


const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import("../views/login/Login.vue")
  },
  {
    path: '/sale',
    name: 'Sale',
    component: () => import("../views/salon-view/sale/Sale.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/cost',
    name: 'Cost',
    component: () => import("../views/salon-view/cost/Cost.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salonCashRegister',
    name: 'SalonCashRegister',
    component: () => import("../views/salon-view/cash-register/SalonCashRegister.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/advancePanel',
    name: 'AdvancePanel',
    component: () => import("../views/salon-view/advance/AdvancePanel.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/dailyReport',
    name: 'DailyReport',
    component: () => import("../views/salon-view/daily-report/DailyReport.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/tasks',
    name: 'TasksPanel',
    component: () => import("../views/salon-view/tasks/TasksPanel.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salon/products',
    name: 'SalonProducts',
    component: () => import("../views/salon-view/product/SalonProducts.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/admin/tasks',
    name: 'AdminTasks',
    component: () => import("../views/admin-view/tasks/AdminTasks.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/dailyReports',
    name: 'DailyReportsAdminPanel',
    component: () => import("../views/admin-view/daily-report/DailyReportsAdminPanel.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salonsOverview',
    name: 'SalonsOverview',
    component: () => import("../views/admin-view/salons-overview/SalonsOverview.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salon/:id',
    name: 'SalonDetails',
    component: () => import("../views/admin-view/salon-details/SalonDetails.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salon/:id/terminal',
    name: 'Terminal',
    component: () => import("../views/admin-view/terminal/Terminal.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/adminCashRegister',
    name: 'AdminCashRegister',
    component: () => import("../views/admin-view/cash-register/AdminCashRegister.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salaries',
    name: 'Salaries',
    component: () => import("../views/admin-view/salaries/Salaries.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salonAdd',
    name: 'SalonAdd',
    component: () => import("../views/admin-view/salon-add/SalonAdd.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/salonEdit/:id',
    name: 'SalonEdit',
    component: () => import("../views/admin-view/salon-add/SalonEdit.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/employeeAdd',
    name: 'EmployeeAdd',
    component: () => import("../views/admin-view/employee/EmployeeAdd.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/employeeEdit',
    name: 'EmployeeEdit',
    component: () => import("../views/admin-view/employee/EmployeeEdit.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/notes',
    name: 'Notes',
    component: () => import("../views/admin-view/notes/Notes.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import("../views/admin-view/product/Products.vue"),
    beforeEnter: requireAdmin
  },
  {
    path: '/vouchers',
    name: 'AdminVouchers',
    component: () => import("../views/admin-view/voucher/AdminVouchers.vue"),
    beforeEnter: requireAdmin
  },
  {
    path: '/productAdd',
    name: 'ProductAdd',
    component: () => import("../views/admin-view/product/ProductAdd.vue"),
    beforeEnter: requireAdmin
  },
  {
    path: '/productEdit/:id',
    name: 'ProductEdit',
    component: () => import("../views/admin-view/product/ProductEdit.vue"),
    beforeEnter: requireAdmin
  },
  {
    path: '/advances/:salonId',
    name: 'Advance',
    component: () => import("../views/admin-view/advances/Advances.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/costs',
    name: 'Costs',
    component: () => import("../views/admin-view/costs/Costs.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/dataCleanup',
    name: 'DataCleanup',
    component: () => import("../views/admin-view/data-cleanup/DataCleanup.vue"),
    beforeEnter: requireAuth
  },
  {
    path: '/changePassword',
    name: 'ChangePasswordView',
    component: () => import("../views/admin-view/user/ChangePasswordView.vue"),
    beforeEnter: requireAuth
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


let isInitialNavigation = true;
router.beforeEach((to, from, next) => {
  const userType = localStorage.getItem('userType');

  if (
    isInitialNavigation &&
    userType === 'ADMIN' &&
    to.name === 'SalonEdit'
  ) {
    isInitialNavigation = false;
    return next({ name: 'SalonsOverview' });
  }

  isInitialNavigation = false;
  next();
});


export default router
